import { FC } from 'react';
import { ReactComponent as Cursor } from '../../assets/icon/cursor_down.svg';
import { ReactComponent as Mail } from '../../assets/icon/mail.svg';
import { ReactComponent as Tel } from '../../assets/icon/tel.svg';
import { ReactComponent as Logo } from '../../assets/logo/andCOCO_logo.svg';
import { ReactComponent as Logo2 } from '../../assets/logo/cocopet2.svg';
import { Menu } from '../../constants/Menu';
import { LinkButton } from '../buttons/LinkButton.client';
import { Collapse } from '../Collapse.client';
import { Link } from '../Link.client';
import { Responsive } from '../Responsive.client';
import { Copyright } from './Copyright';
import { GuideMenu } from './GuideMenu.client';
import { Newsletter } from './Newsletter.client';
import { QuickLink } from './QuickLink.client';

interface Props {
  newsletterError?: string;
}

export const Footer: FC<Props> = (props) => (
  <Responsive desktop={DesktopFooter} mobile={MobileFooter} props={props} />
);

const DesktopFooter: FC<Props> = (props) => (
  <footer>
    <QuickLink />
    <GuideMenu />
    <div className="bg-brand py-12">
      <div className="wrapper text-white">
        <h2 className="text-center text-lg">
          <span className="mr-5 font-outfit text-3xl">CONTACT</span>お問合わせ
        </h2>
        <div className="mt-4 flex flex-row justify-center">
          <div className="mr-12 flex flex-col items-center">
            <Link route="contact">
              <div className="flex flex-col items-center border border-white px-20 py-2">
                <p>メールでのお問い合わせ</p>
                <div className="flex flex-row items-center">
                  <Mail className="mr-2 fill-white" />
                  <p className="text-2xl font-outfit">CONTACT FORM</p>
                </div>
              </div>
            </Link>
            <p className="mt-2 text-sm font-outfit">
              <a href="mailto:support@cocopet.jp">support@cocopet.jp</a>
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-col items-center border border-white px-20 py-2">
              <p>お電話でのお問い合わせ</p>
              <div className="flex flex-row items-center">
                <Tel className="mr-2 fill-white" />
                <p className="text-2xl font-outfit">
                  <a href="tel:0120-18-8800">0120-18-8800</a>
                </p>
              </div>
            </div>
            {/* <p className="mt-2 text-sm">受付時間：平日9:00-18:00</p> */}
          </div>
        </div>
      </div>
    </div>
    <Newsletter {...props} />
    <div className="bg-background py-12">
      <div className="wrapper grid grid-cols-4 flex-col gap-4">
        {Menu.map((section, i) => (
          <div key={i}>
            {section.map((menu, j) => (
              <div key={j}>
                <p className="border-b border-black pb-1 font-semibold">
                  <span className="mr-2 font-outfit text-xs">{menu.subTitle}</span>
                  {menu.title}
                </p>
                <ul className="my-4">
                  {menu.items.map((item, k) => (
                    <li key={k} className="mb-2">
                      <Link {...item.route} className="text-sm">
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
        <div>
          <div className="flex flex-col items-center border-b border-black pt-4 pb-8">
            <Logo width={150} />
            <Link route="contact" className="w-full">
              <LinkButton title="お問合せ" className="mt-4" />
            </Link>
            <div className="mt-2 flex flex-row">
              <Mail className="mr-2" />
              <p className="font-outfit">
                <a href="mailto:support@cocopet.jp">support@cocopet.jp</a>
              </p>
            </div>
            <div className="mt-2 flex flex-row">
              <Tel className="mr-2" />
              <p className="font-outfit text-xl">
                <a href="tel:0120-18-8800">0120-18-8800</a>
              </p>
            </div>
            {/* <p className="text-sm">
              受付時間：平日<span className="font-outfit">9:00-18:00</span>
            </p> */}
          </div>
          <div className="flex flex-col items-center pt-8 pb-4">
            <p className="font-semibold">ペットの葬儀はこちら</p>
            <Logo2 className="mt-2" />
            <Link route="url" url="https://cocopet.jp" target="_blank" className="w-full">
              <LinkButton title="ペットの火葬と葬儀" className="mt-4" />
            </Link>
            <div className="mt-2 flex flex-row">
              <Tel className="mr-2" />
              <p className="font-outfit text-xl">
                <a href="tel:0120-18-8800">0120-18-8800</a>
              </p>
            </div>
            <p className="text-sm">受付時間：24時間365日対応</p>
          </div>
        </div>
      </div>
    </div>
    <Copyright />
  </footer>
);

const MobileFooter: FC<Props> = (props) => (
  <footer>
    <QuickLink />
    <GuideMenu />
    <div className="bg-brand py-12">
      <div className="text-white">
        <p className="text-center text-lg">
          <span className="mr-5 font-outfit text-3xl">CONTACT</span>お問合わせ
        </p>
        <div className="mt-4 px-4">
          <div>
            <Link route="contact">
              <div className="flex flex-col items-center border border-white px-20 py-2">
                <p className="text-sm">メールでのお問い合わせ</p>
                <div className="flex flex-row items-center">
                  <Mail className="mr-2 fill-white" />
                  <p className="font-outfit text-lg">CONTACT FORM</p>
                </div>
              </div>
            </Link>
            <p className="mt-2 text-center font-outfit text-sm">
              <a href="mailto:support@cocopet.jp">support@cocopet.jp</a>
            </p>
          </div>
          <div className="mt-6">
            <a href="tel:0120188800">
              <div className="flex flex-col items-center border border-white px-20 py-2">
                <p className="text-sm">お電話でのお問い合わせ</p>
                <div className="flex flex-row items-center">
                  <Tel className="mr-2 fill-white" />
                  <p className="font-outfit text-lg">0120-18-8800</p>
                </div>
              </div>
            </a>
            {/* <p className="mt-2 text-center text-sm">
              受付時間：平日<span className="font-outfit">9:00-18:00</span>
            </p> */}
          </div>
        </div>
      </div>
    </div>
    <Newsletter {...props} />
    <div>
      {Menu.map((section) =>
        section.map((menu, i) => (
          <div key={i}>
            <Collapse
              header={(open) => (
                <div className="flex items-center justify-between border-b border-lightGray bg-thinGray p-4">
                  <p className="text-left text-sm font-semibold">
                    <span className="mr-2 font-outfit text-xs">{menu.subTitle}</span>
                    {menu.title}
                  </p>
                  <Cursor className={open ? 'rotate-180 transform' : ''} />
                </div>
              )}
            >
              <ul className="mb-4 px-4">
                {menu.items.map((item, j) => (
                  <li key={j} className="my-2">
                    <Link {...item.route} className="text-sm">
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </Collapse>
          </div>
        )),
      )}
    </div>
    <div className="px-4">
      <div className="flex flex-col items-center border-b border-black py-8">
        <Logo />
        <Link route="contact" className="w-72">
          <LinkButton title="お問合せ" className="mt-4 w-full" />
        </Link>
        <div className="mt-2 flex flex-row">
          <Mail className="mr-2" />
          <p className="font-outfit">
            <a href="mailto:support@cocopet.jp">support@cocopet.jp</a>
          </p>
        </div>
        <div className="mt-2 flex flex-row">
          <Tel className="mr-2" />
          <p className="font-outfit text-xl">
            <a href="tel:0120-18-8800">0120-18-8800</a>
          </p>
        </div>
        {/* <p className="text-sm">受付時間：平日9:00-18:00</p> */}
      </div>
      <div className="flex flex-col items-center py-8">
        <p className="font-semibold">ペットの葬儀はこちら</p>
        <Logo2 className="mt-2" />
        <Link route="url" url="https://cocopet.jp" target="_blank" className="w-72">
          <LinkButton title="ペットの火葬と葬儀" className="mt-4 w-full" />
        </Link>
        <div className="mt-2 flex flex-row">
          <Tel className="mr-2" />
          <p className="text-xl">
            <a href="tel:0120-18-8800">0120-18-8800</a>
          </p>
        </div>
        <p className="text-sm">受付時間：24時間365日対応</p>
      </div>
    </div>
    <Copyright />
  </footer>
);
